module.exports = __webpack_public_path__ + "static/media/studentPortal1.16855950.png";